/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_After_Saved_BodyInputs */

const en_us2_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Everything you logged is kept in your history.`)
};

const pt_br2_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo o que você registrou está guardado no seu histórico.`)
};

const es_419_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Todo lo que registraste queda guardado en tu historial.`)
};

const pt_pt2_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tudo o que registaste está guardado no teu histórico.`)
};

const fr_fr2_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout ce que tu as enregistré est conservé dans ton historique.`)
};

const de_de2_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles, was du erfasst hast, bleibt in deinem Verlauf.`)
};

const it_it2_workout_after_saved_body = /** @type {(inputs: Workout_After_Saved_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tutto quello che hai registrato è conservato nel tuo storico.`)
};

/**
* | output |
* | --- |
* | "Everything you logged is kept in your history." |
*
* @param {Workout_After_Saved_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_after_saved_body = /** @type {((inputs?: Workout_After_Saved_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_After_Saved_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_after_saved_body(inputs)
	if (locale === "es-419") return es_419_workout_after_saved_body(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_after_saved_body(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_after_saved_body(inputs)
	if (locale === "de-DE") return de_de2_workout_after_saved_body(inputs)
	if (locale === "it-IT") return it_it2_workout_after_saved_body(inputs)
	return en_us2_workout_after_saved_body(inputs)
});
export { workout_after_saved_body as "workout-after.saved_body" }